import { Box, Text, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import React, { useMemo } from 'react';
export const HeadingStructureRuleGenericGeneratedState = _ref => {
  let {
    aiSuggestion,
    texts,
    transComponents = {},
    showAiSuggestion = true,
    formatAiSuggestion
  } = _ref;
  const mergedComponents = useMemo(() => ({
    boldText: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "bold"
    }),
    ...transComponents
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [transComponents]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP2"
  }, /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: [{
      label: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "SP1",
        padding: "0 0 SP4 0"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny"
      }, /*#__PURE__*/React.createElement(Trans, {
        components: mergedComponents
      }, texts.firstStep)))
    }, ...(showAiSuggestion ? [{
      label: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        padding: "0 0 SP4 0"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }, formatAiSuggestion ? formatAiSuggestion(aiSuggestion) : aiSuggestion))
    }] : []), {
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny"
      }, /*#__PURE__*/React.createElement(Trans, {
        components: mergedComponents
      }, texts.thirdStep))
    }],
    skin: "dark"
  }));
};
//# sourceMappingURL=heading-structure-rule-genric-generated-state.js.map